var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgFaceWash = function SvgFaceWash(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 600 600",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 13,
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 29
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#015e85",
    floodOpacity: 0.45
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 13,
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 29
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#015e85",
    floodOpacity: 0.45
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 13,
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-3",
    stdDeviation: 29
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#015e85",
    floodOpacity: 0.45
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-3",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168.11 78.64c-3.75-.31-7.7 1.3-9.19 4.81 1.66-3.21 5.53-4.97 9.19-4.81zM47.15 181.38c3.56 2.67 10.9.76 12.59-3.14-2.6 3.83-8.52 5.34-12.59 3.14zM72.94 109.29c-1.96-1.21-5.74-.34-6.73 1.71 1.47-1.96 4.52-2.72 6.73-1.71zM56.3 165.16c-3.36-2.4-10.45-.71-12.26 3.2 2.57-3.69 8.24-5.13 12.26-3.2zM172.84 254.89c-5.18-4.48-16.96-2.55-20.36 3.4 4.66-5.6 14.13-7.15 20.36-3.4zM156.23 279.88c5.19 4.44 16.71 2.37 20.15-3.43-4.64 5.5-13.94 7.12-20.15 3.43zM170 96.18c2.44-.63 4.59-2.12 5.64-4.49-1.08 2.23-3.22 3.77-5.64 4.49zM178.76 265zM67.94 118.56c2.01 1.47 6.08.42 7.04-1.79-1.48 2.12-4.74 2.98-7.04 1.79zM549.39 315.95c.22-3.33-.77 4.74-1.54 5.21.95-1.54 1.48-3.36 1.54-5.21zM532.61 308.04c1.61-1.16 3.89-2.11 7.01-2.71-3.07-.07-5.39 1.02-7.01 2.71zM366.02 434.45c-24.44-.06-48.87-.01-73.31 0h76.51-3.2zM529.97 316.78c.49 4.84 4.29 9.2 10.27 8.66-4.27-.65-8.74-4.47-10.27-8.66zM476.76 248.59c.58 1.98 1.67 3 2.95 3.32-1.15-.43-2.19-1.46-2.95-3.32zM481.82 240.59zM174.54 81.86c.82 1.12 1.39 2.54 1.56 4.31-.09-1.74-.68-3.17-1.56-4.31zM158.17 88.08c0 2.02.58 3.68 1.55 4.97-.87-1.29-1.26-3.35-1.55-4.97zM486.48 248.64c1.19-1.68 1.6-3.69.43-5.34.97 1.62.62 3.63-.43 5.34zM455.58 395.99c-1.78 1.29-3.03 3.1-3.78 5.13.76-2.03 2.02-3.84 3.78-5.13zM462.89 393.98c.98.01 1.89.12 2.74.3-.85-.19-1.77-.3-2.74-.3zM543.61 476.52h.15-.15zM461.47 418c-2.13-.11-3.93-.72-5.42-1.69 1.48.99 3.3 1.58 5.42 1.69zM487.12 555.81c2.3 2.29 7.83 1.59 9.48-1.12-2.27 2.54-6.7 3.06-9.48 1.12zM542.81 500.55c-2.19-.11-4.04-.74-5.55-1.74 1.51 1.04 3.38 1.65 5.55 1.74zM536.91 478.52c-2.73 1.94-4.25 5.05-4.6 8.36.39-3.29 1.92-6.41 4.6-8.36zM470.07 415.61c3.76-2.98 5.08-8.72 3.71-13.36 1.28 4.69-.02 10.23-3.71 13.36zM550.58 498.73c3.79-2.53 5.41-7.26 4.91-11.71.44 4.45-1.24 9.17-4.91 11.71zM544.27 476.52c1.9.03 3.56.42 4.97 1.08-1.42-.68-3.08-1.07-4.97-1.08zM495.3 544.77c-2.2-1.92-7.19-1.53-8.92.82 2.28-2.18 6.28-2.52 8.92-.82z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M406.99 124.1c-24.13.59-176.75-11.54-178.78 6.22 5.14 101.6 20.27 202.78 29.66 304.14h34.84c24.44-.02 48.87-.07 73.31 0H380.58c5.56-102.36 32.47-210.09 26.4-310.36z",
    fill: "#16a99e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M150.95 184.77c-72.38 10.76-53.82 124.18 18.22 111.3 72.38-10.76 53.82-124.18-18.22-111.3zm25.43 91.68c-11.53 15.76-35.4-3-23.9-18.16 11.49-15.88 35.63 2.99 23.9 18.16z",
    fill: "#f4abe0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.84 157.62c-34.49 5.13-25.64 59.17 8.68 53.03 34.48-5.13 25.64-59.17-8.68-53.03zm17.89 20.62c-6.03 10.49-22.2.15-15.7-9.88 6.28-10.42 21.95-.05 15.7 9.88z",
    fill: "#6ab4e5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M454.82 382.97c-45.52-.66-45.52 70.83 0 70.16 45.51.66 45.51-70.83 0-70.16zm19.47 23.68c-.41 17.5-27.63 13.11-23.02-3.72 2.52-14.05 24.74-10.35 23.02 3.72z",
    fill: "#16a99e"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M545.49 334.51c38.06.56 38.06-59.24 0-58.68-38.07-.56-38.07 59.24 0 58.68zm-12.88-26.48c8.25-8.36 21.83 3.3 15.24 13.12-7.46 13.02-26.21-4.25-15.24-13.12z",
    fill: "#6ab4e5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71.64 93.67c-22.93 3.41-17.05 39.35 5.77 35.27 22.93-3.41 17.05-39.35-5.77-35.27zm3.33 23.1c-3.49 6-12.67-.06-8.76-5.77 3.56-5.71 12.41.39 8.76 5.77z",
    fill: "#16a99e"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M480.32 261.51c25.31.37 25.31-39.39 0-39.02-25.31-.37-25.31 39.39 0 39.02zm-3.86-16.81c.76-5.15 8.71-4.85 10.44-1.4 3.85 9-12.85 12.77-10.44 1.4z",
    fill: "#6ab4e5",
    filter: "url(#a)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M482.9 536.42c-30.27-.44-30.27 47.11 0 46.66 30.27.44 30.27-47.1 0-46.66zm13.71 18.27c-5.62 7.18-16.42-2.1-10.35-8.97 5.67-6.63 15.86 2.59 10.35 8.97z",
    fill: "#f4abe0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M170.19 105.59c40.78-6.06 30.32-69.96-10.26-62.71-40.78 6.06-30.32 69.96 10.26 62.71zm-11.27-22.15c5.26-10.47 21.75-2.47 16.72 8.24-5.44 10.5-22.04 2.69-16.72-8.24zM545.95 438.82c-53.82-.79-53.82 83.76 0 82.97 53.82.79 53.82-83.76 0-82.97zm4.63 59.91c-13.04 8.75-25.8-11.55-13.43-20.38 13.2-8.67 25.87 11.61 13.43 20.38z",
    fill: "#6ab4e5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M178.76 265c-1.2-19.17-33.55-13.89-28.6 4.68 1.34 19.24 33.52 13.86 28.6-4.68zM158.55 89.81c1.44 11.21 20.63 7.39 17.56-3.65-.92-12.37-21.66-7.99-17.56 3.65zM72.94 109.29c-6.02-2.85-10.61 6.09-5 9.28 6.07 3.1 11.09-5.99 5-9.28zM56.3 165.16c-10.49-5.11-19.09 10.13-9.15 16.22 10.64 5.7 19.65-10.39 9.15-16.22z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M540.23 325.45c9.39 1.67 12.63-15.47 3.96-19.14-16.32-5.65-19.49 16.82-3.96 19.14z",
    fill: "#fff",
    filter: "url(#b)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M473.78 402.25c-2.63-11.77-21.77-10.61-22.68 1.61-3.21 19.82 28.28 17.52 22.68-1.61zM555.49 487.02c-.73-14.3-23.49-13.6-23.25.81-1.53 17.33 25.78 16.29 23.25-.81z",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M476.76 248.59c2.62 7.99 13.2.6 10.14-5.29-3.12-5.42-13.39-1.49-10.14 5.29z",
    fill: "#fff",
    filter: "url(#c)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M495.3 544.77c-7.27-4.91-14.89 5.98-8.17 11.04 7.24 5.05 15.41-5.7 8.17-11.04z",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdb73e",
    d: "M292.71 434.46h-34.84v14.74h123.05v-14.74H292.71zM346.33 456.67c0 6.62-5.37 11.99-11.99 11.99h-22.51c-6.62 0-11.99-5.37-11.99-11.99v-.05h-41.97v6.98c0 9.94 8.06 18 18 18h87.04c9.94 0 18-8.06 18-18v-6.98h-34.58v.05z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#6ab4e5",
    d: "M257.87 449.29v7.32h41.98v-.43h46.48v.43h34.59v-7.41H257.87v.09z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M311.83 468.65h22.51c6.62 0 11.99-5.37 11.99-11.99v-.49h-46.49v.49c0 6.62 5.37 11.99 11.99 11.99z",
    fill: "#015e85"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFaceWash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/face_wash.436a309e.svg";
export { ForwardRef as ReactComponent };